// extracted by mini-css-extract-plugin
export default {"form-button":"permanent-policy-application-form-module__form-button--TPD","formButton":"permanent-policy-application-form-module__form-button--TPD"};